import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '../../components/login/loginActions';

export function useSessionExpired() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleSessionExpired = () => {
      localStorage.removeItem('persist:local');
      localStorage.removeItem('persist:session');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('ray_auth');      
      dispatch(logoutRequest());
    };

    window.addEventListener('session-expired', handleSessionExpired);
    
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, [dispatch]);
}
